// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"d22e094f","622":"fab774d0"}[chunkId] + ".chunk.js";
};